import { render, staticRenderFns } from "./MenuCategoryCard.vue?vue&type=template&id=8dde0532&scoped=true&"
import script from "./MenuCategoryCard.vue?vue&type=script&lang=js&"
export * from "./MenuCategoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dde0532",
  null
  
)

export default component.exports